import React = require("react");
import "./Loader.scss";
import {Spinner, SpinnerSize} from "@vebox/etui-core";

/**
 * Loading animation.
 * It will be centered to the div it is inserted into.
 */
interface LoaderProps {
    spinnerSize?: SpinnerSize
    relativelyCentered?: boolean
    color?: string
}

export const Loader = (props: LoaderProps) => {
    return (
        // The css class .loader centers the div with the spinner absolutely in its parent
        <div
            className={props.relativelyCentered ? "" : "loader"}
        >
            <Spinner
                size={props.spinnerSize ? props.spinnerSize : SpinnerSize.large}
                {...props}
            />
        </div>
    );
};
